var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-dialog",
        {
          attrs: { "content-class": "va-dialog", scrollable: "" },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-form",
            {
              ref: "addYtForm",
              attrs: { "lazy-validation": "", onSubmit: "return false;" },
              on: { submit: _vm.onAddYoutube },
              model: {
                value: _vm.valid,
                callback: function($$v) {
                  _vm.valid = $$v
                },
                expression: "valid"
              }
            },
            [
              _c("va-card", [
                _c(
                  "div",
                  { staticClass: "d-flex" },
                  [
                    _c(
                      "div",
                      { staticClass: "va-title d-flex align-center mr-auto" },
                      [
                        _c("i", {
                          staticClass: "vi vi-logo-youtube mt-1 mr-4"
                        }),
                        _vm._v(" " + _vm._s(_vm.$t("ds.addYtToPlaylist")) + " ")
                      ]
                    ),
                    _c("va-button", {
                      staticClass: "mt-1 ml-8",
                      attrs: {
                        color: "secondary",
                        cta: _vm.$t("common.dismiss"),
                        icon: "vi vi-i-remove-1",
                        type: "square"
                      },
                      on: {
                        click: function($event) {
                          _vm.dialog = false
                        }
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "mb-4 align-center" },
                  [
                    _c("va-text-field", {
                      staticClass: "mb-4",
                      attrs: {
                        label: _vm.$t("ds.youtubeUrl"),
                        rules: [_vm.required]
                      },
                      model: {
                        value: _vm.ytMedia.downloadUrl,
                        callback: function($$v) {
                          _vm.$set(_vm.ytMedia, "downloadUrl", $$v)
                        },
                        expression: "ytMedia.downloadUrl"
                      }
                    }),
                    _c("va-text-field", {
                      staticClass: "mb-4",
                      attrs: {
                        label: _vm.$t("ds.ytVideoName"),
                        rules: [_vm.required]
                      },
                      model: {
                        value: _vm.ytMedia.name,
                        callback: function($$v) {
                          _vm.$set(_vm.ytMedia, "name", $$v)
                        },
                        expression: "ytMedia.name"
                      }
                    }),
                    _c("va-button", {
                      staticClass: "float-right",
                      attrs: {
                        submit: "",
                        disabled: !_vm.valid,
                        icon: "vi vi-d-add",
                        cta: "add"
                      }
                    })
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _c("va-button", {
        staticClass: "mr-4",
        attrs: {
          icon: "vi vi-logo-youtube",
          type: "outline",
          cta: _vm.$t("ds.addFromYt")
        },
        on: { click: _vm.openDialog }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }